exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.gradient[data-v-1cb3dab8] {\n    background: linear-gradient(90deg, #ff5e62 10%, #ff9966 90%);\n    -webkit-background-clip: text !important;\n    -webkit-text-fill-color: transparent !important;\n}\n.layout-title[data-v-1cb3dab8] {\n    text-align : center !important;\n}\n.flex-center[data-v-1cb3dab8] {\n    display         : flex !important;\n    justify-content : center !important;\n}\n.stepper[data-v-1cb3dab8] .v-stepper__step__step {\n    background-color : #ff8765 !important;\n}\n.stepper[data-v-1cb3dab8] .v-stepper__label {\n    text-shadow : none !important;\n    color: rgba(0,0,0,.87) !important;\n}\n", ""]);

// exports
